import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import InputField from 'components/Form/InputField';
import Validators from 'helpers/formValidator';
import { useSelector } from 'react-redux';
import { reduxForm } from 'redux-form';

const ContactForm = ({ handleSubmit }) => {
  //   handleChange = event => {
  //     this.setState({ [event.target.name]: event.target.value });
  //   };

  //   componentDidMount = () => {
  //     this.validator = new SimpleReactValidator({}, 'fr');
  //   };

  //   handleSubmit = () => {
  //     if (this.validator.allValid() && !this.props.loading) {
  //       const mailData = {
  //         fullName: this.state.fullname,
  //         email: this.state.email,
  //         phone: this.state.phone,
  //         organisation: this.state.company,
  //         message: this.state.message,
  //       };

  //       this.props.callback(mailData);
  //     } else {
  //       this.validator.showMessages();
  //       // rerender to show messages for the first time
  //       this.forceUpdate();
  //     }
  //   };
  const loading = useSelector(state => state.loading.loading);

  return (
    <form onSubmit={handleSubmit}>
      <div className="container space-3 space-md-3">
        <div className="row justify-content-start">
          <div className="col-sm-10 col-md-8 col-lg-8 col-xl-7" style={{ opacity: 0.9 }}>
            <div className="card position-absolute border-0 shadow-sm">
              <div className="card-body p-7">
                <div className="mb-4">
                  <h2 className="font-weight-normal mb-0">Contactez nous</h2>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-7 text-center">
                    <div className="px-lg-3">
                      <span className="btn-soft-primary mb-5 btn btn-icon btn-lg  rounded-circle">
                        <span className="fas fa-map-marker-alt fa-2x btn-icon__inner" />
                      </span>
                    </div>
                    <p className="mb-md-0">8 Résidence Mehdi - Cité El Khalil - La Marsa - 2070 - Tunis - Tunisie</p>
                  </div>
                  <div className="col-md-6 mb-7 text-center">
                    <div className=" px-lg-3">
                      <a
                        href="mailto:contact@pulpground.com"
                        className="btn-soft-primary mb-5 btn btn-icon btn-lg  rounded-circle"
                      >
                        <span className="fas fa-envelope fa-2x btn-icon__inner " />
                      </a>
                    </div>
                    <p className="mb-md-0">contact@pulpground.com</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <InputField
                      name="fullName"
                      label="Nom et Prénom"
                      placeholder="Nom et Prénom"
                      validate={[Validators.required]}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputField
                      name="email"
                      label="Email"
                      placeholder="Email"
                      validate={[Validators.required, Validators.email]}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <InputField name="phone" label="Téléphone" placeholder="Téléphone" />
                  </div>
                  <div className="col-md-6">
                    <InputField name="company" label="Organisation" placeholder="Organisation" />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <InputField
                      type="textarea"
                      name="message"
                      label="Votre message"
                      placeholder="Votre message"
                      validate={[Validators.required]}
                    />
                  </div>
                </div>
                <div className="media align-items-center mt-4">
                  <button type="submit" className="btn btn-primary btn-wide transition-3d-hover mr-3">
                    {loading ? <CircularProgress style={{ width: 25, height: 25 }} /> : 'Envoyer'}
                  </button>
                  <div className="media-body">
                    <small className="d-flex justify-content-end text-muted">
                      Ou bien appelez nous directement sur le
                    </small>
                    <a
                      href="tel:+21629699869"
                      className="d-flex justify-content-end text-primary font-weight-semi-bold"
                    >
                      +216 29 699 869
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

ContactForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'contactForm' })(ContactForm);
